import { render, staticRenderFns } from "./TermsSetting.vue?vue&type=template&id=59ecb768&"
import script from "./TermsSetting.vue?vue&type=script&lang=js&"
export * from "./TermsSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports